import { render, staticRenderFns } from "./DonateBlock.vue?vue&type=template&id=9b6f9464&scoped=true&"
import script from "./DonateBlock.vue?vue&type=script&lang=js&"
export * from "./DonateBlock.vue?vue&type=script&lang=js&"
import style0 from "./DonateBlock.vue?vue&type=style&index=0&id=9b6f9464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6f9464",
  null
  
)

export default component.exports